import type { TabSliderForm } from "./tab-slider-form";
import type { TabSliderHandler } from "./tab-slider-handler";

export class TabSliderListener {
    public form: TabSliderForm;

    public handler: TabSliderHandler;

    public constructor(form: TabSliderForm, handler: TabSliderHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.tabSliderListenerBound === "1") return;
        root.dataset.tabSliderListenerBound = "1";

        const track = this.form.getTrack();
        const prevButton = this.form.getPrevButton();
        const nextButton = this.form.getNextButton();

        if (prevButton instanceof HTMLButtonElement) {
            prevButton.addEventListener("click", (event) => {
                this.handler.handlePrevClick(event);
            });
        }

        if (nextButton instanceof HTMLButtonElement) {
            nextButton.addEventListener("click", (event) => {
                this.handler.handleNextClick(event);
            });
        }

        if (track instanceof HTMLElement) {
            track.addEventListener("scroll", () => {
                this.handler.handleTrackScroll();
            });

            track.addEventListener("click", (event) => {
                this.handler.handleTrackClick(event);
            });

            const observer = new MutationObserver(() => {
                this.handler.handleMutations();
            });

            observer.observe(track, {
                subtree: true,
                attributes: true,
                attributeFilter: ["class", "aria-selected", "hidden"],
            });
        }

        if (typeof globalThis.addEventListener === "function") {
            globalThis.addEventListener("resize", () => {
                this.handler.handleResize();
            });
        }
    }
}
